import React, { useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { List, AutoSizer } from 'react-virtualized'
import './gotoTop.css'
// const listStyle = { overflowX: false, overflowY: false }; //สั่งปิด scrollbar พื้นฐานของ html เพื่อจะใช้ scrollbar ตัวที่เรา custom เอง
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        height: '100%',
    },
    noRows: {
        // position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1em',
        color: '#bdbdbd',
    },
}))

const VirtualizedView = (props: any) => {
    const {
        layoutStyle = {},
        rowCount,
        rowHeight,
        rowRenderer,
        onScrollEnd,
        rowPerpage,
        currentIndex,
        scrollToIndex,
        isGotoTop,
        onClickGotoTop,
    } = props
    const currentPage = useRef(1)
    // const refList = useRef()
    const [gotoTop, setGotoTop] = React.useState<boolean>(false)
    const [currentIndex2, setCurrentIndex2] = React.useState<number>()
    let classes = useStyles()

    const _noRowsRenderer = () => {
        return <div className={classes.noRows}>ไม่พบข้อมูล</div>
    }

    return (
        // <List width={300} height={500} rowCount={20} rowHeight={80} rowRenderer={rowRenderer} />
        // <Grid container className={classes.root} style={layoutStyle}>
        <>
            {/* <span
                id="button"
                onClick={() => {
                    // if (onClickGotoTop) {
                    //     onClickGotoTop()
                    // }
                    // setGotoTop(true)
                    // setCurrentIndex2()
                }}
            ></span> */}

            <AutoSizer>
                {(
                    { height, width }, //ได้ width height มาตาม div ที่ครอบมัน
                ) => (
                    // <ScrollBar onScroll={handleScroll} style={{ height, width }} noScrollX={true}>
                    <List
                        height={height}
                        width={width}
                        rowCount={rowCount} //{rowCount}
                        rowHeight={110} //{rowHeight}
                        rowRenderer={rowRenderer}
                        scrollToIndex={isGotoTop ? 0 : undefined}
                        // scrollTop={currentIndex}
                        // style={listStyle}
                        // ref={refList}\
                        overscanRowCount={10}
                        onRowsRendered={(props: any) => {
                            const { overscanStartIndex, overscanStopIndex, startIndex, stopIndex } = props
                        }}
                        onScroll={(props: any) => {
                            const { clientHeight, scrollHeight, scrollTop } = props

                            if (scrollHeight - scrollTop === clientHeight) {
                                if (onScrollEnd) {
                                    // onScrollEnd(rowPerpage * (currentPage.current + 1))
                                    onScrollEnd(rowPerpage * (currentIndex + 1), currentIndex + 1)
                                }
                                currentPage.current = currentPage.current + 1
                            }
                        }}
                        noRowsRenderer={_noRowsRenderer}
                    />

                    // </ScrollBar>
                )}
            </AutoSizer>
        </>
    )
}

export default VirtualizedView
